import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CONTACT_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getContactReferenceData = createAsyncThunk(
  'stop/getContactReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(CONTACT_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const contactReferenceDataSlice = createSlice({
  name: 'stop/contactReferenceData',
  initialState: null,
  reducers: {
    resetContactReferenceData: () => null,
  },
  extraReducers: {
    [getContactReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetContactReferenceData } = contactReferenceDataSlice.actions;

export default contactReferenceDataSlice.reducer;
